
import { CustomLabelDialog, isLabelContentType, LabelContentItem } from '@tableau/catalog-ui-temp';
import React from 'react';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { CatalogProviders } from '~src/catalog/CatalogProviders';
import { getItemsWithCorrectLuids } from '~src/Collections/sagas/CollectionSagas';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { Messages } from '../../../codegen/Localize';
import { SetCustomLabelAction } from '../../actions/labels/SetCustomLabelAction';

export type CustomLabelDialogState = {
    readonly luid?: string;
    readonly note: string;
    readonly showCustomLabel: boolean;
}

export type CustomLabelDialogBodyProps = {
    readonly contentItem: LabelContentItem;
    readonly loading?: boolean;
}

/**
 * @deprecated remove with unifiedLabelsDialogEnabled
 */
export function* handleSetCustomLabel(action: SetCustomLabelAction) {
    try {
        yield call(openCustomLabelDialog, action);

        const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
        if (!maybeReloaded) {
          yield put(requestSpaceContents());
        }
    } catch(e) {
        yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

/**
 * @deprecated remove with unifiedLabelsDialogEnabled
 */
export function openCustomLabelDialogCatalog({ contentItem }: {
    readonly contentItem: LabelContentItem;
    readonly onSubmit?: () => void;
  }): Promise<unknown>  {

    const modal = ReactModalService.openCustom(closeAndDismiss => {
      return (
        <CatalogProviders>
          <CustomLabelDialog
          contentItem={contentItem}
          close={closeAndDismiss.close}
          dismiss={closeAndDismiss.dismiss}
          />
        </CatalogProviders>
        );
    });
    return Promise.resolve(modal.result);
}

/**
 * @deprecated remove with unifiedLabelsDialogEnabled
 */
export function openCustomLabelDialog(action: SetCustomLabelAction): PromiseLike<unknown> {
    const itemWithCorrectLuid = getItemsWithCorrectLuids([action.item])[0];
    const { luid: contentId, name: contentName, contentType } = itemWithCorrectLuid;
    if (!isLabelContentType(contentType)) {
      throw new Error(`${contentType} Custom Label cannot be put on this content type`);
    }

    const contentItem: LabelContentItem = { contentId, contentName, contentType };

    return openCustomLabelDialogCatalog({ contentItem });
}